import { jwtDecode } from 'jwt-decode'
import {DecodedToken} from "../interfaces/decodeToken";

export const decodeToken = (token: string): DecodedToken | null => {
    try {
        const decoded = jwtDecode<DecodedToken>(token);
        return decoded;
    } catch (error) {
        console.error('Invalid token:', error);
        return null;
    }
};
